import * as UserCentrics from "../../../ts/shared/user-centrics";

const reommendationForm: HTMLFormElement = document.querySelector("#RecomendationForm") as HTMLFormElement;
const tokenFormElement: HTMLInputElement = document.querySelector("input[name=Token]") as HTMLInputElement;
const siteKeyFormElement: HTMLInputElement = document.querySelector("#siteKey") as HTMLInputElement;
const receiverMailFormElement: HTMLInputElement = document.querySelector(
	"input[name=ReceiverEmail]"
) as HTMLInputElement;
const senderMailFormElement: HTMLInputElement = document.querySelector("input[name=SenderEmail]") as HTMLInputElement;

declare global {
	interface Window {
		turnstile: any;
	}
}

/**
 * Callback funktion. Wird von Recaptcha aufgerufen
 * @param token Recaptcha Token
 */
async function OnRecommendationSubmit(ev: Event): Promise<void> {
	if (!UserCentrics.IsCloudflareAllowed()) {
		ev.preventDefault();
		return;
	}

	let formIsValid = true;

	if (!receiverMailFormElement.value) {
		formIsValid = false;
		receiverMailFormElement.setAttribute("style", "border-color: #de343a");
	}
	if (!senderMailFormElement.value) {
		formIsValid = false;
		senderMailFormElement.setAttribute("style", "border-color: #de343a");
	}

	if (!formIsValid) {
		ev.preventDefault();
	}

	if (!window.turnstile && !window.turnstile.getResponse()) {
		ev.preventDefault();
		return;
	}

	tokenFormElement.value = window.turnstile.getResponse();
	reommendationForm.submit();
}

export const RecommendationFormSubmit = (): void => {
	reommendationForm.addEventListener("submit", OnRecommendationSubmit);
};
